import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'isObsolete' })
export class IsObsoletePipe implements PipeTransform {
  transform(lookupValues: any[]) {
    return lookupValues?.filter(lut => lut && !lut.obsoleteFlag);
  }
}
